import { UPLOAD_TYPES } from 'constants.js'
import { PLATFORM_VALUE } from 'biz-components/ChannelPkgList/constants'
import React from 'react'

export const SINGLE_UPLOAD_RADIO = [
    { value: UPLOAD_TYPES.LOCAL_UPLOAD, children: '本地上传渠道包' },
    { value: UPLOAD_TYPES.INPUT_LINK, children: '填写下载链接' },
]
export const MULTI_UPLOAD_RADIO = [
    { value: UPLOAD_TYPES.LOCAL_UPLOAD, children: '本地上传渠道包' },
    { value: UPLOAD_TYPES.UPLOAD_LINK_CSV, children: '本地上传下载链接' },
]

export const APK_PLATFORM_RADIO = [
    { value: PLATFORM_VALUE.Bit32, children: '32位安装包' },
    { value: PLATFORM_VALUE.Bit64, children: '64位安装包' },
    { value: PLATFORM_VALUE.Bit32And64, children: '32-64兼容包' },
]

// 提示文案
export const SINGLE_UPLOAD_TIPS = [
    <>1. 仅支持apk格式 , 3G以内。</>,
    <>
        2. 上传的渠道包名称需要标注位数信息，
        <span style={{ color: 'red' }}>渠道包名称格式建议按规范填写：应用名-活动名-cp渠道号-包体位数，</span>例如“
        京东-双十一活动-1008-32 ”，” 京东-双十一活动-1008-64 “，” 京东-双十一活动-1008-32-64 “ 。
    </>,
    <>3. 渠道包上传后会进入审核状态，通过审核后将自动上线，可在投放时进行选择。审核时间一般不超过2个小时。</>,
    <>4. 为了避免上传失败，建议使用 chrome 浏览器。</>,
]

export const SINGLE_UPLOAD_ULR_TIPS = [
    <>
        1. <span style={{ color: 'red' }}>请规范填写名称，应用名-活动名-cp渠道号-包体位数，</span>例如“
        京东-双十一活动-1008-32 ”，” 京东-双十一活动-1008-64 “，” 京东-双十一活动-1008-32-64 “ 。
    </>,
    <>2. 渠道包上传后会进入审核状态，通过审核后将自动上线，可在投放时进行选择。审核时间一般不超过2个小时。</>,
    <>3. 为了避免上传失败，建议使用 chrome 浏览器。</>,
]
